import React from 'react';
import { IMaskInput } from 'react-imask';
import styled from 'styled-components';
import InputStyles from './InputStyles';

interface IRecoveryInputProps {
  type?: string;
  disabled?: boolean;
  id?: string;
  placeholder?: string;
  onBlur?: (e: Event) => void;
  onChange?: (e: Event) => void;
  value?: string;
}

interface IMask {
  mask: string;
}

const StyledImaskInput = styled(IMaskInput).attrs({
  inputMode: 'numeric',
})`
  ${InputStyles}
`;

const defaultPinMask: IMask[] = [{ mask: '0000' }];

const RecoveryPinInput: React.FC<IRecoveryInputProps> = (props) => {
  const comboMask: any = {
    mask: [...defaultPinMask],
    unmask: true,
    lazy: false,
  };

  return <StyledImaskInput data-cy="recovery-pin-input" {...comboMask} {...props} />;
};

export default RecoveryPinInput;
